export interface HotTopic {
  rank: number;
  title: string;
  category: string;
  heat: string;
  discussion: string;
  trend: "up" | "down" | "new" | "flat";
  summary: string;
  tags: string[];
}

export interface FanRiser {
  rank: number;
  name: string;
  field: string;
  gained: string;
  note: string;
}

export interface TopicCategory {
  name: string;
  desc: string;
  count: string;
  icon: string;
  tone: "primary" | "accent" | "secondary";
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export interface TimelineNode {
  time: string;
  text: string;
}

export const site = {
  brand: "瓜田热榜",
  slogan: "全网吃瓜热榜聚合",
  intro:
    "瓜田热榜是一个聚焦全网吃瓜话题的热榜聚合首页，实时汇总热度榜、热议榜、爆款排行与围观涨粉榜。谁在涨粉、谁被群嘲、哪个话题最有来龙去脉，打开首页就能一眼看清。",
  email: "hi@gua-tian-hotlist.cn",
  wechat: "GuaTianHotlist",
  updatedAt: "更新于每天 08:00 / 12:00 / 20:00",
};

export const liveTicker: string[] = [
  "热度榜 · 顶流新剧开机路透流入前十",
  "热议榜 · 综艺剪辑话题单小时讨论破 10 万",
  "涨粉榜 · 综艺名场面档案馆单日涨粉 18.2 万",
  "爆款榜 · 三分钟看懂年度短片播放破 900 万",
  "热度榜 · 小城早餐店十八年话题连续三天上榜",
  "热议榜 · 品牌联名定价引发网友两极评价",
];

export const heroStats = [
  { label: "今日上榜话题", value: "1,286", unit: "个" },
  { label: "实时热度峰值", value: "4286.7", unit: "万" },
  { label: "参与讨论网友", value: "96.4", unit: "万" },
  { label: "榜单更新频次", value: "3", unit: "次 / 天" },
];

export const hotTopics: HotTopic[] = [
  {
    rank: 1,
    title: "#顶流新剧开机路透流出#",
    category: "娱乐八卦",
    heat: "4286.7万",
    discussion: "32.4万",
    trend: "up",
    summary:
      "该剧尚未官宣阵容，一组拍摄地路透先在社交平台流传，造型与取景地成为网友讨论焦点，话题在半天内冲上热度首位。",
    tags: ["路透", "新剧", "造型讨论"],
  },
  {
    rank: 2,
    title: "#某综艺录制现场气氛失控#",
    category: "综艺名场面",
    heat: "3912.3万",
    discussion: "28.9万",
    trend: "up",
    summary:
      "一段现场观众拍摄的短视频流出，嘉宾互动环节出现意外状况，节目组暂未回应，网友围绕剪辑与真实情况展开讨论。",
    tags: ["综艺", "现场", "剪辑争议"],
  },
  {
    rank: 3,
    title: "#小城早餐店老板的十八年#",
    category: "社会热点",
    heat: "3564.1万",
    discussion: "21.6万",
    trend: "new",
    summary:
      "一条记录街边早餐店十八年坚持的短片走红，价格与手艺几乎没有变化，评论区涌入大量本地回忆与打卡分享。",
    tags: ["烟火气", "小店", "短片"],
  },
  {
    rank: 4,
    title: "#电竞决赛第五局名场面#",
    category: "电竞圈",
    heat: "2987.5万",
    discussion: "25.1万",
    trend: "up",
    summary:
      "关键局一次团战决策成为全场转折，赛后复盘视频被反复转发，选手的临场判断在论坛里被逐帧拆解。",
    tags: ["电竞", "决赛", "复盘"],
  },
  {
    rank: 5,
    title: "#某品牌联名被指定价过高#",
    category: "品牌争议",
    heat: "2654.8万",
    discussion: "19.7万",
    trend: "down",
    summary:
      "联名系列开售后定价引发讨论，部分消费者认为性价比不足，品牌客服回应称限量款成本较高，话题热度稍有回落。",
    tags: ["联名", "定价", "消费讨论"],
  },
  {
    rank: 6,
    title: "#网红直播翻车现场合集#",
    category: "网红动态",
    heat: "2418.6万",
    discussion: "17.3万",
    trend: "flat",
    summary:
      "网友整理近期直播中的口误与突发状况，剪辑成合集后迅速传播，多位主播的临场反应被拿出来对比。",
    tags: ["直播", "合集", "名场面"],
  },
  {
    rank: 7,
    title: "#年代剧口碑悄悄逆袭#",
    category: "影视热评",
    heat: "2103.4万",
    discussion: "12.8万",
    trend: "up",
    summary:
      "开播时讨论度一般的年代剧，随着剧情推进口碑走高，观众开始自发安利，长评数量明显增长。",
    tags: ["年代剧", "口碑", "长评"],
  },
  {
    rank: 8,
    title: "#选秀选手初舞台引发争议#",
    category: "综艺名场面",
    heat: "1876.2万",
    discussion: "15.4万",
    trend: "down",
    summary:
      "一位选手的初舞台表现评价两极，导师点评片段被单独截取传播，讨论从实力延伸到赛制设置。",
    tags: ["选秀", "初舞台", "赛制"],
  },
  {
    rank: 9,
    title: "#某歌手巡演临时调整场次#",
    category: "娱乐八卦",
    heat: "1642.9万",
    discussion: "11.2万",
    trend: "new",
    summary:
      "主办方发布公告称因场馆安排调整部分场次，退票与改签方案同步公布，粉丝在评论区询问具体执行细节。",
    tags: ["巡演", "场次", "公告"],
  },
  {
    rank: 10,
    title: "#短视频博主发布道歉视频#",
    category: "网红动态",
    heat: "1425.3万",
    discussion: "9.8万",
    trend: "flat",
    summary:
      "针对此前争议内容，博主发布长视频说明经过并致歉，评论区对道歉诚恳度有不同看法，话题热度趋于平稳。",
    tags: ["道歉", "回应", "网友评价"],
  },
];

export const discussTopics: HotTopic[] = [
  {
    rank: 1,
    title: "#为流量妥协到底值不值#",
    category: "话题讨论",
    heat: "3218.6万",
    discussion: "46.2万",
    trend: "up",
    summary:
      "一位创作者公开分享了为迎合算法而改变风格的经历，评论区就内容与流量之间的取舍展开了长时间讨论。",
    tags: ["创作", "流量", "观点交锋"],
  },
  {
    rank: 2,
    title: "#综艺剪辑该不该背锅#",
    category: "话题讨论",
    heat: "2987.2万",
    discussion: "41.5万",
    trend: "up",
    summary:
      "接连两个话题都与剪辑节奏有关，网友开始讨论剪辑对观众判断的影响，节目组与嘉宾各有说法。",
    tags: ["剪辑", "节目", "舆论"],
  },
  {
    rank: 3,
    title: "#该不该给网红打赏#",
    category: "话题讨论",
    heat: "2641.9万",
    discussion: "38.7万",
    trend: "flat",
    summary:
      "围绕直播打赏的讨论再度升温，支持与反对两派各执一词，话题延伸到平台规则与消费者保护。",
    tags: ["直播", "打赏", "消费"],
  },
  {
    rank: 4,
    title: "#追剧要不要看剧透#",
    category: "话题讨论",
    heat: "2318.4万",
    discussion: "33.1万",
    trend: "up",
    summary:
      "热播剧更新节奏引发剧透争论，有人喜欢提前了解剧情，有人坚持不被剧透，双方在评论区互相说服。",
    tags: ["追剧", "剧透", "习惯"],
  },
  {
    rank: 5,
    title: "#明星人设能维持多久#",
    category: "话题讨论",
    heat: "2076.5万",
    discussion: "29.8万",
    trend: "down",
    summary:
      "随着几起反差事件出现，讨论焦点从个体转向行业现象，网友更关心人设与真实之间的边界。",
    tags: ["人设", "行业", "观察"],
  },
  {
    rank: 6,
    title: "#短视频里的真实生活#",
    category: "话题讨论",
    heat: "1834.7万",
    discussion: "24.6万",
    trend: "up",
    summary:
      "一批记录普通人日常的账号受到关注，网友讨论镜头里的生活究竟有几分真实、几分修饰。",
    tags: ["记录", "日常", "真实"],
  },
];

export const viralTopics: HotTopic[] = [
  {
    rank: 1,
    title: "#三分钟看懂年度最佳短片#",
    category: "爆款视频",
    heat: "986.4万次播放",
    discussion: "12.8万",
    trend: "up",
    summary:
      "一条结构精巧的短片凭借反转结尾走红，二创解说版本同步爆发，成为本周播放增长最快的视频之一。",
    tags: ["短片", "反转", "二创"],
  },
  {
    rank: 2,
    title: "#方言版新闻播报太离谱#",
    category: "爆款视频",
    heat: "872.1万次播放",
    discussion: "10.4万",
    trend: "up",
    summary:
      "用方言重新演绎新闻播报的创意视频获得大量转发，网友纷纷留言点播自己想听的方言版本。",
    tags: ["创意", "方言", "转发"],
  },
  {
    rank: 3,
    title: "#把公司食堂拍成纪录片#",
    category: "爆款视频",
    heat: "764.5万次播放",
    discussion: "9.1万",
    trend: "new",
    summary:
      "一位博主用纪录片手法拍摄公司食堂日常，旁白与运镜引发代入感，评论区开始集体晒自家食堂。",
    tags: ["纪录", "职场", "代入感"],
  },
  {
    rank: 4,
    title: "#老手艺人的最后一批订单#",
    category: "爆款视频",
    heat: "698.2万次播放",
    discussion: "8.6万",
    trend: "up",
    summary:
      "记录老手艺人赶制收尾订单的短片打动了不少观众，关于传统手艺传承的讨论随之增加。",
    tags: ["手艺", "传承", "温柔"],
  },
  {
    rank: 5,
    title: "#用一百天还原一座微缩老城#",
    category: "爆款视频",
    heat: "612.7万次播放",
    discussion: "7.9万",
    trend: "flat",
    summary:
      "创作者用延时摄影呈现微缩模型的制作过程，细节密度极高，成为手工类内容里的黑马。",
    tags: ["手工", "模型", "延时"],
  },
  {
    rank: 6,
    title: "#深夜食堂的第十年菜单#",
    category: "爆款视频",
    heat: "543.9万次播放",
    discussion: "6.4万",
    trend: "new",
    summary:
      "一家深夜食堂把十年来的菜单做成合辑，老顾客在评论里认领自己常点的那一道菜。",
    tags: ["美食", "故事", "回忆"],
  },
];

export const fansRising: FanRiser[] = [
  {
    rank: 1,
    name: "综艺名场面档案馆",
    field: "综艺剪辑",
    gained: "+18.2万",
    note: "连续三天更新现场合集，单条视频点赞破 40 万。",
  },
  {
    rank: 2,
    name: "小城观察日记",
    field: "生活记录",
    gained: "+14.7万",
    note: "早餐店系列短片带动账号整体关注度上涨。",
  },
  {
    rank: 3,
    name: "剧评人阿岚",
    field: "影视热评",
    gained: "+11.3万",
    note: "一篇年代剧长评被大量转发，粉丝增速明显加快。",
  },
  {
    rank: 4,
    name: "电竞复盘室",
    field: "电竞赛事",
    gained: "+9.8万",
    note: "决赛第五局逐帧复盘视频登上多个平台热榜。",
  },
  {
    rank: 5,
    name: "手工造物周记",
    field: "手工创意",
    gained: "+7.4万",
    note: "微缩老城系列进入爆款榜后带动关注回流。",
  },
  {
    rank: 6,
    name: "深夜食客手记",
    field: "美食探店",
    gained: "+5.9万",
    note: "深夜食堂十年合辑引发老顾客集体回忆。",
  },
];

export const topicCategories: TopicCategory[] = [
  {
    name: "娱乐八卦",
    desc: "路透、官宣与幕后花絮，第一时间跟进。",
    count: "312 个话题",
    icon: "ri-sparkling-2-line",
    tone: "primary",
  },
  {
    name: "综艺名场面",
    desc: "录制现场与名场面合集，笑点槽点全收录。",
    count: "268 个话题",
    icon: "ri-movie-2-line",
    tone: "accent",
  },
  {
    name: "影视热评",
    desc: "剧集口碑与长评观点，追剧前先看风向。",
    count: "204 个话题",
    icon: "ri-clapperboard-line",
    tone: "secondary",
  },
  {
    name: "电竞圈",
    desc: "赛事复盘与选手动态，关键局逐帧拆解。",
    count: "176 个话题",
    icon: "ri-gamepad-line",
    tone: "primary",
  },
  {
    name: "网红动态",
    desc: "账号涨粉与直播翻车，人设变化全记录。",
    count: "241 个话题",
    icon: "ri-user-voice-line",
    tone: "accent",
  },
  {
    name: "社会热点",
    desc: "普通人故事与城市烟火气，有温度的记录。",
    count: "189 个话题",
    icon: "ri-fire-line",
    tone: "secondary",
  },
  {
    name: "品牌争议",
    desc: "联名、定价与消费讨论，理性看待每一次争议。",
    count: "132 个话题",
    icon: "ri-shopping-bag-3-line",
    tone: "primary",
  },
  {
    name: "情感话题",
    desc: "关系与选择的长久讨论，观点交锋不停歇。",
    count: "158 个话题",
    icon: "ri-heart-3-line",
    tone: "accent",
  },
];

export const deepDive = {
  kicker: "本周最值得从头看的话题",
  title: "#顶流新剧开机路透# 的完整来龙去脉",
  highlight: "从第一张路透到话题登顶，用了不到 11 个小时。",
  intro:
    "这件事之所以能冲上热度榜首，并不是因为它有多复杂，而是每个阶段都恰好踩中了网友想讨论的点。下面按时间顺序把关键节点梳理清楚，看完你就明白它为什么会火。",
  timeline: [
    {
      time: "08:40",
      text: "拍摄地附近的路透照片首次出现在社交平台，画面中出现了疑似剧组布景与演员造型。",
    },
    {
      time: "10:15",
      text: "多个娱乐账号转发同一组照片，话题标签被创建，初始讨论集中在造型是否符合原著设定。",
    },
    {
      time: "12:30",
      text: "剧方尚未回应，网友开始自行比对原著情节，衍生出人物关系与选角的两条讨论线。",
    },
    {
      time: "15:20",
      text: "一段现场短视频流出，取景地细节被放大讨论，话题首次进入热度榜前十。",
    },
    {
      time: "19:05",
      text: "影视博主的分析长文被大量转发，讨论从造型延伸到制作班底与播出平台猜测。",
    },
  ],
  points: [
    {
      title: "为什么容易火",
      text: "路透自带悬念感，官方未回应意味着信息缺口，网友会主动补全猜测，讨论自然发酵。",
    },
    {
      title: "讨论集中在哪",
      text: "造型还原度、选角适配度、取景地氛围是三大高频词，其中造型相关的评论占比最高。",
    },
    {
      title: "目前进展",
      text: "剧方暂未发布正式阵容信息，网络流传内容仍以网友整理为主，建议以官方公告为准。",
    },
  ],
  related: ["#某综艺录制现场气氛失控#", "#年代剧口碑悄悄逆袭#", "#选秀选手初舞台引发争议#"],
};

export const faqs: FaqItem[] = [
  {
    q: "瓜田热榜的榜单多久更新一次？",
    a: "热度榜与热议榜每天固定更新三次，分别在早八点、中午十二点和晚八点；遇到讨论量骤增的话题会临时补更新，涨粉榜与爆款榜则跟随每日数据同步刷新。",
  },
  {
    q: "热度榜、热议榜、爆款排行有什么区别？",
    a: "热度榜看综合关注量，反映话题被多少人看到；热议榜看讨论量与观点交锋，适合了解争议点；爆款排行按播放或转发增长排序，用来发现正在快速传播的内容。",
  },
  {
    q: "上榜话题的内容来源是什么？",
    a: "内容由编辑对各平台公开讨论进行整理与归类，只做事实梳理和观点呈现，不编造未经证实的细节，涉及具体人物的表述统一采用代称。",
  },
  {
    q: "为什么有些话题只用某顶流、某综艺这样的代称？",
    a: "使用代称是为了避免对未确认信息下结论，也减少对当事人的无谓打扰。站内更关注话题本身的发展脉络，而不是给个人下定论。",
  },
  {
    q: "可以在站内搜索自己关心的话题吗？",
    a: "目前首页提供话题分类浏览与榜单切换，搜索与筛选功能正在规划中，后续会按分类和热度区间快速定位感兴趣的瓜。",
  },
  {
    q: "发现信息有误怎么办？",
    a: "可以发送邮件到联系方式中的邮箱，并附上话题链接与更正依据。核实后我们会尽快修订对应的内容摘要，并在页面更新说明中标注。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿正",
    role: "每天通勤刷榜",
    text: "以前要在几个平台之间来回翻，现在早上一打开就是当天最值得看的几个话题，省事不少。",
  },
  {
    name: "栗子",
    role: "综艺爱好者",
    text: "热议榜最对胃口，同一个话题下面能看到完全不同的两种观点，比单纯看热闹有意思多了。",
  },
  {
    name: "大刘",
    role: "内容创作者",
    text: "涨粉榜对我来说很实用，能看到最近哪些方向的内容在起量，找选题的时候会来参考一下。",
  },
  {
    name: "小满",
    role: "路人吃瓜",
    text: "话题复盘写得挺清楚，按时间线看下来基本不会一头雾水，也不用担心被一堆真假消息绕晕。",
  },
];